import styled from "styled-components";

const Container = styled.div`
    box-sizing: border-box;
    border: 1px solid #ddd;
    width: 100%;
    height: 100%;
    background-color: #f3f3f3;
    border-radius: 8px;
    overflow: auto;
    display: flex;
    flex-direction: column;
    &::-webkit-scrollbar {
        height: 8px;
        width: 12px;
        background-color: #f0f0f0;
    }
    &::-webkit-scrollbar-thumb {
        background-color: #c1c1c1;
        border-radius: 4px;
        border: 3px solid #f0f0f0;
        border-radius: 8px;
    }
`
const Tabela = styled.table`
    width: 100%;
    border-collapse: collapse;
    color: #333;
    thead {
        background-color: #f0f0f0;
        position: sticky;
        top: 0;
        th {
            text-align: left;
            padding-left: 12px;
            font-weight: bold;
            white-space: nowrap;
            padding-right: 5px;
        }
        th:last-child{
            padding-right: 15px;
        }
        tr{
            height: 40px;
            border-bottom: 1px solid #ccc;
            &:last-child{
                border-bottom: none;
            }
        }
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    }
    tbody {
        tr {
            height: 35px;
            border-bottom: 1px solid #e1e1e1;
            &:nth-child(even) {
                background-color: #f9f9f9;
            }
            &:nth-child(odd) {
                background-color: #ffffff;
            }
            &:last-child {
                border-bottom: none;
            }
            td {
                padding-left: 12px;
                //white-space: nowrap;
                padding-right: 10px;
            }
            &:hover {
                background-color: #e8f0fe;
            }
        }
    }
`


const Tabela2 = ({ children }) => {
    return (
        <>
            <Container>
                <Tabela>
                    { children }
                </Tabela>
            </Container>
        </>
    )
}

export default Tabela2;